import { html } from "lit";

export const checkIcon = html`
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M4 12L9 17L20 6" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
`;

export const xIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="36"
    height="36"
    fill="currentColor"
    aria-hidden="true">
    <path
      d="M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7a1 1 0 0 0-1.4 1.4L10.6 12l-4.9 4.9a1 1 0 1 0 1.4 1.4L12 13.4l4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4z" />
  </svg>
`;

export const raindropIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="36"
    height="36"
    fill="currentColor"
    aria-hidden="true">
    <path d="M12 3s6.8 7.5 6.8 12.2a6.8 6.8 0 1 1-13.6 0C5.2 10.5 12 3 12 3z" />
  </svg>
`;

export const backIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <path d="M15 18l-6-6 6-6" />
  </svg>
`;

export const rightArrowIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="36"
    height="36"
    fill="none"
    stroke="currentColor"
    stroke-width="2.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <path d="M5 12h14m-6-6 6 6-6 6" />
  </svg>
`;

export const gearIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="currentColor"
    aria-hidden="true">
    <path
      d="M19.43 12.98c.04-.32.07-.65.07-.98s-.03-.66-.07-.98l2.11-1.65a.5.5 0 0 0 .12-.64l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1a7.03 7.03 0 0 0-1.69-.98l-.38-2.65A.5.5 0 0 0 14 0h-4a.5.5 0 0 0-.5.42l-.38 2.65c-.62.24-1.19.56-1.69.98l-2.49-1a.5.5 0 0 0-.61.22l-2 3.46a.5.5 0 0 0 .12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98L2.46 14.63a.5.5 0 0 0-.12.64l2 3.46c.14.24.43.34.7.22l2.49-1c.5.42 1.07.75 1.69.98l.38 2.65c.04.27.26.42.5.42h4c.24 0 .46-.15.5-.42l.38-2.65c.62-.24 1.19-.56 1.69-.98l2.49 1c.27.12.56.02.7-.22l2-3.46a.5.5 0 0 0-.12-.64l-2.11-1.65ZM12 15.5A3.5 3.5 0 1 1 12 8.5a3.5 3.5 0 0 1 0 7Z" />
  </svg>
`;

export const speakerIcon = html`
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M4 9v6h4l5 4V5L8 9H4Z" fill="currentColor" />
    <path
      d="M16 9.5a4 4 0 0 1 0 5M18.5 7a7.5 7.5 0 0 1 0 10"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round" />
  </svg>
`;

export const uploadIcon = html`
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M12 21V8M12 8L7 13M12 8L17 13"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M4 4H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
`;

export const lockIcon = html`
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" stroke-width="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
`;

export const unlockIcon = html`
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" stroke-width="2" />
    <path d="M8 11V8a4 4 0 0 1 7-1.2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
`;

export const instructionsIcon = html`
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M5 4h9a3 3 0 0 1 3 3v13H8a3 3 0 0 0-3 3V4z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round" />
    <path d="M17 4h2a2 2 0 0 1 2 2v14h-4V4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
    <path d="M8 8h6M8 12h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
`;

export const versionIcon = html`
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V4h9l8.6 8.6a2 2 0 0 1 0 2.8Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round" />
    <circle cx="8.2" cy="8.2" r="1.15" fill="currentColor" />
  </svg>
`;

export const downloadIcon = html`
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M12 3V16M12 16L7 11M12 16L17 11"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M4 21H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
`;

export const trashIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
`;

export const shareIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
`;

export const plusIcon = html`
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true">
    <rect x="10" y="4" width="4" height="16" />
    <rect x="4" y="10" width="16" height="4" />
  </svg>
`;
